import { useEffect, useState } from 'react';
import { RouterProvider } from 'react-router';

import { AlertComponent } from '@workinance/shared/ui/AlertComponent';
import { OfflineStatusComponent } from '@workinance/shared/ui/OfflineStatusComponent';

import { ErrorBoundaryComponent } from '@/components/ErrorBoundaryComponent';
import { LoadingScreenComponent } from '@/components/LoadingScreenComponent';
import { applicationRoutes } from '@/routes/app.routes';
import { useAuthStore } from '@/store/auth.store';

function App() {
	const restoreAuthentication = useAuthStore(
		(state) => state.restoreAuthentication,
	);
	const theme = useAuthStore((state) => state.user?.preferredTheme);
	const [isReady, setIsReady] = useState(false);

	// Who the user is comes from the device's stored session on every start. Nothing renders until that resolves.
	useEffect(() => {
		void restoreAuthentication().finally(() => setIsReady(true));
	}, [restoreAuthentication]);

	return (
		<ErrorBoundaryComponent>
			<AlertComponent theme={theme} />
			{isReady ? (
				<RouterProvider router={applicationRoutes} />
			) : (
				<LoadingScreenComponent />
			)}
			<OfflineStatusComponent />
		</ErrorBoundaryComponent>
	);
}

export default App;
